export type OfferType = "permanent" | "gift";
export const OfferTypes = new Set(["permanent", "gift"]);
import labels from "./types.json";
export { labels };
